<template>
    <app-layout title="Data Penyedia">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc"/>
        </template>
        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-5 mx-auto">
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <div>
                                    <Dialog header="Undang Klarifikasi" :visible="displayBasic" :modal="true"
                                            :closable="false" :style="{ width: '50vw' }">
                                        <div class="p-fluid px-3 mb-3">
                                            <div class="p-field">
                                                <JetLabel
                                                    class="w-full"
                                                    for="tanggal"
                                                    value="Tanggal Undangan"
                                                />
                                                <Input
                                                    id="tanggal"
                                                    v-model="tanggal"
                                                    type="datetime-local"
                                                    placeholder=""
                                                    class="mt-1 block w-full"
                                                />
                                            </div>
                                        </div>
                                        <div class="p-fluid px-3 mb-3">
                                            <div class="p-field">
                                                <JetLabel
                                                    class="w-full"
                                                    for="lokasi"
                                                    value="Lokasi Klarifikasi"
                                                />
                                                <Input
                                                    id="lokasi"
                                                    v-model="lokasi"
                                                    type="text"
                                                    placeholder=""
                                                    class="mt-1 block w-full"
                                                />
                                            </div>
                                        </div>
                                        <div class="p-fluid px-3 mb-3">
                                            <div class="p-field">
                                                <JetLabel
                                                    class="w-full"
                                                    for="keterangan"
                                                    value="Keterangan Klarifikasi"
                                                />
                                                <Input
                                                    id="keterangan"
                                                    v-model="keterangan"
                                                    type="text"
                                                    placeholder=""
                                                    class="mt-1 block w-full"
                                                />
                                            </div>
                                        </div>
                                        <div class="p-fluid px-3 mb-3">
                                            <div class="p-field">
                                                <JetLabel
                                                    class="w-full"
                                                    for="no_hp"
                                                    value="Contact Person"
                                                />
                                                <Input
                                                    id="no_hp"
                                                    v-model="no_hp"
                                                    type="text"
                                                    placeholder=""
                                                    class="mt-1 block w-full"
                                                />
                                            </div>
                                        </div>
                                        <template #footer>
                                            <div class="p-d-flex p-jc-end">
                                                <Button label="Batal" @click="displayBasic=false"/>
                                                <Button label="Undang" @click="undangKlarifikasi"/>
                                            </div>
                                        </template>
                                    </Dialog>
                                </div>
                              <div class="mb-3">
                                <Message severity="warn">
                                  Agar dapat melanjutkan proses dengan cepat, harap diperhatikan untuk melengkapi seluruh data yang masih kurang dan mengunggah dokumen yang diperlukan sesegera mungkin. Terima kasih atas kerjasama Anda.
                                </Message>
                              </div>
                                <div class="mb-3">
                                    <Message severity="warn" v-if="dataPenyedia.status == '1' ">Data Tersimpan, Menunggu
                                        data diverifikasi oleh petugas.
                                    </Message>
                                    <Message severity="success" v-if="dataPenyedia.status == '3' ">Data Telah
                                        Terverifikasi
                                    </Message>
                                    <Message severity="error" v-if="dataPenyedia.status == '2'">Undangan Klarifikasi,
                                        Undangan Klarifikasi data telah dikirim.
                                    </Message>
                                    <Message severity="error" v-if="dataPenyedia.status == '4'">Data anda ditunda,
                                        silahkan menghubungi Tim DRM (KPBJ)
                                    </Message>
                                </div>
                                <div class="w-full mb-6 lg:mb-0 flex flex-row-reverse">
                                    <div class="mb-2"
                                         v-if="(dataPenyedia.status == '1' || dataPenyedia.status == '2' || dataPenyedia.status == '4' || dataPenyedia.status == NULL) && $page.props.session_role.role.name == 'penyedia'">
                                        <ButtonLinkEdit class="mr-1" :href="route('penyedia.edit', dataPenyedia.id)"><b>Ubah
                                            Data / Lengkapi Data</b></ButtonLinkEdit>
                                    </div>
                                    <!--                                    vif status = 3 dan selected role = 'timdrm-->
                                    <div class="mb-2"
                                         v-else-if="$page.props.session_role.role.name == 'timdrm' && dataPenyedia.status == '3'">
                                        <ButtonLinkEdit class="mr-1" :href="route('penyedia.edit', dataPenyedia.id)"><b>Ubah
                                            Data / Lengkapi Data</b></ButtonLinkEdit> {{$page.props.session_role.role.name}}
                                    </div>
                                </div>

                                <Accordion :multiple="true" :activeIndex="[0]">

                                    <AccordionTab :disabled="true">
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Data Utama</span>
                                                <span class="text-xs text-green-500" v-if="dataPenyediaKelengkapan.data_utama == 1">Lengkap</span>
                                                <span class="text-xs text-red-500" v-if="dataPenyediaKelengkapan.data_utama == 0">Belum Di Verifikasi</span>
                                            </span>
                                        </template>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="nama_perusahaan"
                                                    value="Nama Perusahaan"
                                                />
                                                <Input
                                                    id="nama_perusahaan"
                                                    v-model="dataPenyedia.nama_perusahaan"
                                                    type="text"
                                                    placeholder=""
                                                    class="mt-1 block w-full"
                                                    :readonly="true"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="npwp_perusahaan"
                                                    value="NPWP Perusahaan"
                                                />
                                                <Input
                                                    id="npwp_perusahaan"
                                                    v-model="dataPenyedia.npwp_perusahaan"
                                                    class="mt-1 block w-full"
                                                    :readonly="true"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="nama_pemberi_kuasa"
                                                    value="Nama Direktur"
                                                />
                                                <Input
                                                    id="nama_pemberi_kuasa"
                                                    v-model="dataPenyedia.nama_pemberi_kuasa"
                                                    type="text"
                                                    placeholder=""
                                                    class="mt-1 block w-full"
                                                    :readonly="true"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="nama_penerima_kuasa"
                                                    value="Nama Penerima Kuasa"
                                                />
                                                <Input
                                                    id="nama_penerima_kuasa"
                                                    v-model="dataPenyedia.nama_penerima_kuasa"
                                                    type="text"
                                                    placeholder=""
                                                    class="mt-1 block w-full"
                                                    :readonly="true"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="alamat_perusahaan"
                                                    value="Alamat Perusahaan"
                                                />
                                                <Input
                                                    id="alamat_perusahaan"
                                                    v-model="dataPenyedia.alamat_perusahaan"
                                                    type="text"
                                                    placeholder=""
                                                    class="mt-1 block w-full"
                                                    :readonly="true"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="alamat_perusahaan_semarang"
                                                    value="Alamat Perusahaan Semarang"
                                                />
                                                <Input
                                                    id="alamat_perusahaan_semarang"
                                                    v-model="dataPenyedia.alamat_perusahaan_semarang"
                                                    type="text"
                                                    placeholder="(optional)"
                                                    class="mt-1 block w-full"
                                                    :readonly="true"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="jenis_pekerjaan"
                                                    value="jenis Pekerjaan"
                                                />
                                                <Input
                                                    id="jenis_pekerjaan"
                                                    v-model="dataPenyedia.jenis_pekerjaan.nama_pekerjaan"
                                                    type="text"
                                                    placeholder="(optional)"
                                                    class="mt-1 block w-full"
                                                    :readonly="true"
                                                />
                                            </div>
                                        </div>
                                        <!--                                        tombol 'lengkap' dan 'tidak lengkap' if selected role timdrm-->
                                        <div class="mt-6 lg:w-full md:w-full"
                                             v-if="$page.props.session_role.role.name == 'timdrm'">
                                            <div class="w-full px-3 text-center">
                                                <div class="card flex justify-center flex-wrap gap-3">
                                                    <Button @click="lengkap($event,'data_utama')" label="Lengkap"
                                                            raised/>
                                                    <Button severity="danger" raised
                                                            @click="tidaklengkap($event,'data_utama')"
                                                            label="Belum Di Verifikasi"/>
                                                </div>
                                            </div>
                                        </div>

                                    </AccordionTab>
                                    <AccordionTab>
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Data File Tambahan</span>
                                                <span class="text-xs text-green-500" v-if="dataPenyediaKelengkapan.data_file == 1">Lengkap</span>
                                                <span class="text-xs text-red-500" v-if="dataPenyediaKelengkapan.data_file == 0">Belum Di Verifikasi</span>
                                            </span>
                                        </template>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="akta_notaris"
                                                    value="Akta Notaris (bisa lebih dari 1 File .pdf)"
                                                />
                                                <ul id="example-1">
                                                    <li v-for="(item, index) in dataPenyediaFile.penyedia_file_akta_notaris"
                                                        :key="item.id">
                                                        <ButtonShow v-bind:label="item"
                                                                    @click="visible1[index] = true"/>
                                                        <Dialog v-model:visible="visible1[index]" modal
                                                                v-bind:header="item" :style="{ width: '50vw' }">
                                                            <pdf :src="'/storage/'+handleHashing(dataPenyedia.id)+'/'+item"/>
                                                        </Dialog>
                                                    </li>
                                                </ul>

                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="nib"
                                                    value="NIB dan Ijin Usaha Liannya (bisa lebih dari 1 File .pdf)"
                                                />
                                                <ul id="example-1">
                                                    <li v-for="(item, index) in dataPenyediaFile.penyedia_file_nib"
                                                        :key="item.id">
                                                        <ButtonShow v-bind:label="item"
                                                                    @click="visible2[index] = true"/>
                                                        <Dialog v-model:visible="visible2[index]" modal
                                                                v-bind:header="item" :style="{ width: '50vw' }">
                                                            <pdf :src="'/storage/'+handleHashing(dataPenyedia.id)+'/'+item"/>
                                                        </Dialog>
                                                    </li>
                                                </ul>

                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="perhitungan_kemampuan_dasar"
                                                    value="Perhitungan Kemampuan Dasar (bisa lebih dari 1 File .pdf)"
                                                />

                                                <ul id="example-1">
                                                    <li v-for="(item, index) in dataPenyediaFile.penyedia_file_perhitungan_kemampuan_dasar"
                                                        :key="item.id">
                                                        <ButtonShow v-bind:label="item"
                                                                    @click="visible3[index] = true"/>
                                                        <Dialog v-model:visible="visible3[index]" modal
                                                                v-bind:header="item" :style="{ width: '50vw' }">
                                                            <pdf :src="'/storage/'+handleHashing(dataPenyedia.id)+'/'+item"/>
                                                        </Dialog>
                                                    </li>
                                                </ul>

                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="indikator_keuangan"
                                                    value="Indikator Keuangan (SKN) (bisa lebih dari 1 File .pdf)"
                                                />
                                                <ul id="example-1">
                                                    <li v-for="(item, index) in dataPenyediaFile.penyedia_file_indikator_keuangan"
                                                        :key="item.id">
                                                        <ButtonShow v-bind:label="item"
                                                                    @click="visible4[index] = true"/>
                                                        <Dialog v-model:visible="visible4[index]" modal
                                                                v-bind:header="item" :style="{ width: '50vw' }">
                                                            <pdf :src="'/storage/'+handleHashing(dataPenyedia.id)+'/'+item"/>
                                                        </Dialog>
                                                    </li>
                                                </ul>

                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="spt_badan"
                                                    value="SPT BADAN beserta lampiran (bisa lebih dari 1 File .pdf)"
                                                />
                                                <ul id="example-1">
                                                    <li v-for="(item, index) in dataPenyediaFile.penyedia_file_spt_badan"
                                                        :key="item.id">
                                                        <ButtonShow v-bind:label="item"
                                                                    @click="visible10[index] = true"/>
                                                        <Dialog v-model:visible="visible10[index]" modal
                                                                v-bind:header="item" :style="{ width: '50vw' }">
                                                            <pdf :src="'/storage/'+handleHashing(dataPenyedia.id)+'/'+item"/>
                                                        </Dialog>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="rekening_koran"
                                                    value="Rekening Koran 3 bulan terakhir (bisa lebih dari 1 File .pdf)"
                                                />
                                                <ul id="example-1">
                                                    <li v-for="(item, index) in dataPenyediaFile.penyedia_file_rekening_koran"
                                                        :key="item.id">
                                                        <ButtonShow v-bind:label="item"
                                                                    @click="visible11[index] = true"/>
                                                        <Dialog v-model:visible="visible11[index]" modal
                                                                v-bind:header="item" :style="{ width: '50vw' }">
                                                            <pdf :src="'/storage/'+handleHashing(dataPenyedia.id)+'/'+item"/>
                                                        </Dialog>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="laporan_keuangan_audited"
                                                    value="Laporan Keuangan Audited (bisa lebih dari 1 File .pdf)"
                                                />
                                                <ul id="example-1">
                                                    <li v-for="(item, index) in dataPenyediaFile.penyedia_file_laporan_keuangan_audited"
                                                        :key="item.id">
                                                        <ButtonShow v-bind:label="item"
                                                                    @click="visible12[index] = true"/>
                                                        <Dialog v-model:visible="visible12[index]" modal
                                                                v-bind:header="item" :style="{ width: '50vw' }">
                                                            <pdf :src="'/storage/'+handleHashing(dataPenyedia.id)+'/'+item"/>
                                                        </Dialog>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="laporan_keuangan_unaudited"
                                                    value="Laporan Keuangan Unaudited (bisa lebih dari 1 File .pdf)"
                                                />
                                                <ul id="example-1">
                                                    <li v-for="(item, index) in dataPenyediaFile.penyedia_file_laporan_keuangan_unaudited"
                                                        :key="item.id">
                                                        <ButtonShow v-bind:label="item"
                                                                    @click="visible13[index] = true"/>
                                                        <Dialog v-model:visible="visible13[index]" modal
                                                                v-bind:header="item" :style="{ width: '50vw' }">
                                                            <pdf :src="'/storage/'+handleHashing(dataPenyedia.id)+'/'+item"/>
                                                        </Dialog>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="dokumen_lain"
                                                    value="Dokumen Lainnya (bisa lebih dari 1 File .pdf)"
                                                />
                                                <ul id="example-1">
                                                    <li v-for="(item, index) in dataPenyediaFile.penyedia_file_dokumen_lain"
                                                        :key="item.id">
                                                        <ButtonShow v-bind:label="item"
                                                                    @click="visible5[index] = true"/>
                                                        <Dialog v-model:visible="visible5[index]" modal
                                                                v-bind:header="item" :style="{ width: '50vw' }">
                                                            <pdf :src="'/storage/'+handleHashing(dataPenyedia.id)+'/'+item"/>
                                                        </Dialog>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="mt-6 lg:w-full md:w-full"
                                             v-if="$page.props.session_role.role.name == 'timdrm'">
                                            <div class="w-full px-3 text-center">
                                                <div class="card flex justify-center flex-wrap gap-3">
                                                    <Button @click="lengkap($event,'data_file')" label="Lengkap"
                                                            raised/>
                                                    <Button severity="danger" raised
                                                            @click="tidaklengkap($event,'data_file')"
                                                            label="Belum Di Verifikasi"/>
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab>
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Data Pegawai / Tenaga Ahli</span>
                                                <span class="text-xs text-green-500" v-if="dataPenyediaKelengkapan.data_pegawai == 1">Lengkap</span>
                                                <span class="text-xs text-red-500" v-if="dataPenyediaKelengkapan.data_pegawai == 0">Belum Di Verifikasi</span>
                                            </span>
                                        </template>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <!-- datatable -->
                                            <DataTable :value="dataPenyediaPegawai" tableStyle="min-width: 50rem">
                                                <Column v-for="col of columns" :key="col.field" :field="col.field"
                                                        :header="col.header"></Column>
                                                <Column field="file_pegawai" header="File Pegawai" :sortable="true">
                                                    <template #body="slotProps">
                                                        <!-- {{ slotProps.data }} -->
                                                        <ButtonShow @click="visible6[slotProps.data.id] = true"/>
                                                        <Dialog v-model:visible="visible6[slotProps.data.id]" modal
                                                                v-bind:header="slotProps.data.id"
                                                                :style="{ width: '50vw' }">
                                                            <pdf :src="'/storage/'+handleHashing(dataPenyedia.id)+'/'+slotProps.data.file_pegawai"/>
                                                        </Dialog>
                                                    </template>
                                                </Column>
                                            </DataTable>
                                        </div>
                                        <div class="mt-6 lg:w-full md:w-full"
                                             v-if="$page.props.session_role.role.name == 'timdrm'">
                                            <div class="w-full px-3 text-center">
                                                <div class="card flex justify-center flex-wrap gap-3">
                                                    <Button @click="lengkap($event,'data_pegawai')" label="Lengkap"
                                                            raised/>
                                                    <Button severity="danger" raised
                                                            @click="tidaklengkap($event,'data_pegawai')"
                                                            label="Belum Di Verifikasi"/>
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab>
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Data Kontrak</span>
                                                <span class="text-xs text-green-500" v-if="dataPenyediaKelengkapan.data_kontrak == 1">Lengkap</span>
                                                <span class="text-xs text-red-500" v-if="dataPenyediaKelengkapan.data_kontrak == 0">Belum Di Verifikasi</span>
                                            </span>
                                        </template>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <!-- datatable -->
                                            <DataTable :value="dataPenyediaKontrakHistori"
                                                       tableStyle="min-width: 50rem">
                                                <Column v-for="col of columns2" :key="col.field" :field="col.field"
                                                        :header="col.header"></Column>
                                                <Column field="file_kontrak" header="File Kontrak" :sortable="true">
                                                    <template #body="slotProps">
                                                        <!-- {{ slotProps.data }} -->
                                                        <ButtonShow @click="visible7[slotProps.data.id] = true"/>
                                                        <Dialog v-model:visible="visible7[slotProps.data.id]" modal
                                                                v-bind:header="slotProps.data.id"
                                                                :style="{ width: '50vw' }">
                                                            <pdf :src="'/storage/'+handleHashing(dataPenyedia.id)+'/'+slotProps.data.file_kontrak"/>
                                                        </Dialog>
                                                    </template>
                                                </Column>
                                                <Column field="file_bast" header="File BAST" :sortable="true">
                                                    <template #body="slotProps">
                                                        <!-- {{ slotProps.data }} -->
                                                        <ButtonShow @click="visible8[slotProps.data.id] = true"/>
                                                        <Dialog v-model:visible="visible8[slotProps.data.id]" modal
                                                                v-bind:header="slotProps.data.id"
                                                                :style="{ width: '50vw' }">
                                                            <pdf :src="'/storage/'+handleHashing(dataPenyedia.id)+'/'+slotProps.data.file_bast"/>
                                                        </Dialog>
                                                    </template>
                                                </Column>
                                            </DataTable>
                                        </div>
                                        <div class="mt-6 lg:w-full md:w-full"
                                             v-if="$page.props.session_role.role.name == 'timdrm'">
                                            <div class="w-full px-3 text-center">
                                                <div class="card flex justify-center flex-wrap gap-3">
                                                    <Button @click="lengkap($event,'data_kontrak')" label="Lengkap"
                                                            raised/>
                                                    <Button severity="danger" raised
                                                            @click="tidaklengkap($event,'data_kontrak')"
                                                            label="Belum Di Verifikasi"/>
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab>
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Data Barang / Peralatan</span>
                                                <span class="text-xs text-green-500" v-if="dataPenyediaKelengkapan.data_barang == 1">Lengkap</span>
                                                <span class="text-xs text-red-500" v-if="dataPenyediaKelengkapan.data_barang == 0">Belum Di Verifikasi</span>
                                            </span>
                                        </template>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <!-- datatable -->
                                            <DataTable :value="dataPenyediaBarang" tableStyle="min-width: 50rem">
                                                <Column v-for="col of columns3" :key="col.field" :field="col.field"
                                                        :header="col.header"></Column>
                                            </DataTable>
                                        </div>
                                        <div class="mt-6 lg:w-full md:w-full"
                                             v-if="$page.props.session_role.role.name == 'timdrm'">
                                            <div class="w-full px-3 text-center">
                                                <div class="card flex justify-center flex-wrap gap-3">
                                                    <Button @click="lengkap($event,'data_barang')" label="Lengkap"
                                                            raised/>
                                                    <Button severity="danger" raised
                                                            @click="tidaklengkap($event,'data_barang')"
                                                            label="Belum Di Verifikasi"/>
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab >
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Data KBLI</span>
                                                <span class="text-xs text-green-500" v-if="dataPenyediaKelengkapan.data_kbli == 1">Lengkap</span>
                                                <span class="text-xs text-red-500" v-if="dataPenyediaKelengkapan.data_kbli == 0">Belum Di Verifikasi</span>
                                            </span>
                                        </template>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <!-- datatable -->
                                            <DataTable :value="dataPenyediaKbli" tableStyle="min-width: 50rem">
                                                <Column v-for="col of columns4" :key="col.field" :field="col.field"
                                                        :header="col.header"></Column>
                                            </DataTable>
                                        </div>
                                        <div class="mt-6 lg:w-full md:w-full"
                                             v-if="$page.props.session_role.role.name == 'timdrm'">
                                            <div class="w-full px-3 text-center">
                                                <div class="card flex justify-center flex-wrap gap-3">
                                                    <Button @click="lengkap($event,'data_kbli')" label="Lengkap"
                                                            raised/>
                                                    <Button severity="danger" raised
                                                            @click="tidaklengkap($event,'data_kbli')"
                                                            label="Belum Di Verifikasi"/>
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab header="Catatan TIM DRM (input catatan ubah data dulu kemudian klik tombol simpan)"
                                                  v-if="$page.props.session_role.role.name == 'timdrm'">
                                        <div class="field w-full px-3 mb-3">
                                            <JetLabel
                                                class="w-full"
                                                for="catatan"
                                                value="Catatan TIM DRM (1 File .pdf)"
                                            />

                                            <ButtonShow v-bind:label="dataPenyediaFile.penyedia_file_catatan"
                                                        @click="visible9 = true"/>
                                            <Dialog v-model:visible="visible9" modal
                                                    v-bind:header="dataPenyediaFile.penyedia_file_catatan"
                                                    :style="{ width: '50vw' }">
                                                <pdf :src="'/storage/'+handleHashing(dataPenyedia.id)+'/'+dataPenyediaFile.penyedia_file_catatan"/>
                                            </Dialog>

                                        </div>
                                    </AccordionTab>
                                </Accordion>
                                <div class="mt-6 lg:w-full md:w-full" v-if="$page.props.session_role.role.name == 'timdrm'">
                                    <div class="w-full px-3 text-center">
                                        <div class="card flex justify-center flex-wrap gap-3">
                                            <Button @click="verif($event)" label="Verifikasi" raised/>
                                            <Button severity="warning" outlined @click="undang($event)"
                                                    label="Undang Klarifikasi"/>
                                            <Button severity="danger" raised @click="tolak($event)"
                                                    label="Tunda Penyedia"/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>

                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import {defineComponent} from 'vue'
import {ref} from "vue";
import AppLayout from '@/Layouts/AppLayout.vue'
import JetSectionBorder from '@/Jetstream/SectionBorder.vue'
import BreadCrumb from "@/Components/BreadCrumb";
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input";
import InputError from "@/Components/InputError";
import InputMask from 'primevue/inputmask';
import ButtonSave from "@/Components/ButtonSave";
import ButtonShow from "@/Components/ButtonShow";
import ButtonEdit from "@/Components/ButtonEdit.vue";
import Button from 'primevue/button';
import pdf from "@/Components/Pdf.vue";
import Dialog from 'primevue/dialog';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ButtonLinkEdit from "@/Components/ButtonLinkEdit";
import Message from 'primevue/message';
import {Pesan} from "@/constants";
import md5Hex from "md5-hex";


// const visible = ref(false);
export default defineComponent({

    components: {
        AppLayout,
        JetSectionBorder,
        BreadCrumb,
        Accordion,
        AccordionTab,
        JetLabel,
        Input,
        InputError,
        ButtonSave,
        InputMask,
        pdf,
        ButtonShow,
        Button,
        Dialog,
        DataTable,
        Column,
        ButtonLinkEdit,
        Message,
        ButtonEdit

    },
    props: {

        dataPenyedia: Object,
        dataPenyediaFile: Object,
        dataPenyediaPegawai: Object,
        dataPenyediaKontrakHistori: Object,
        dataPenyediaBarang: Object,
        dataPenyediaKbli: Object,
        dataPenyediaKelengkapan: Object,


    },

    mounted() {
        // console.log('_props_data', {
        //     dataPenyedia: this.dataPenyedia,
        //     dataPenyediaFile: this.dataPenyediaFile,
        //     dataPenyediaPegawai: this.dataPenyediaPegawai,
        //     dataPenyediaKontrakHistori: this.dataPenyediaKontrakHistori,
        //     dataPenyediaBarang: this.dataPenyediaBarang,
        //     dataPenyediaKbli: this.dataPenyediaKbli,
        // })
        // console.log('session_role.role', this.dataPenyediaKelengkapan);
    },
    data() {
        return {
            visible1: [],
            visible2: [],
            visible3: [],
            visible4: [],
            visibleVerifikasi: false,
            displayBasic: false,
            visible5: [],
            visible6: [],
            visible7: [],
            visible8: [],
            visible9: false,
            visible10: [],
            visible11: [],
            visible12: [],
            visible13: [],
            columns: [
                {field: 'nama_pegawai', header: 'Nama Pegawai'},
                {field: 'nik_pegawai', header: 'NIK Pegawai'},
                {field: 'pendidikan_pegawai', header: 'Pendidikan Pegawai'},
                {field: 'keahlian_pegawai', header: 'Keahlian Pegawai'},
            ],
            columns2: [
                {field: 'nomor_kontrak', header: 'Nomor Kontrak'},
                {field: 'nomor_bast', header: 'Nomor BAST'},
                {field: 'pemberi_kerja', header: 'Pemberi Kerja'},
            ],
            columns3: [
                {field: 'nama_barang', header: 'Nama Barang'},
                {field: 'jumlah', header: 'Jumlah'},
            ],
            columns4: [
                {field: 'kode_kbli', header: 'Kode KBLI'},
                {field: 'judul_kbli', header: 'Judul KBLI'},
                {field: 'keterangan_kbli', header: 'Keterangan KBLI'},
            ],
            // dataPenyediaKelengkapan: this.dataPenyediaKelengkapan,


        };
    },
    methods: {

        handleHashing(data) {
            this.hashedMessage = md5Hex(data);
            // console.log(md5Hex(data));
            return this.hashedMessage;
        },
        verif: function (event) {
            this.$confirm.require({
                target: event.currentTarget,
                message:
                    "Apakah akan Verifikasi (" + this.dataPenyedia.nama_perusahaan +
                    ") ?",
                icon: "pi pi-info-circle",
                acceptClass: "p-button-info",
                accept: () => {

                    let cek = true;
                    let penyedia = this.dataPenyedia;
                    if (penyedia.status == '3') {
                        cek = false;
                    }

                    // update data
                    if (cek == false) {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: 'data sudah diverifikasi',
                            life: 3000,
                        });
                        return false;
                    }
                    axios
                        .post(route("penyedia.verifikasi"), {
                            ids: [penyedia.id],
                            status: 3,
                            keterangan: '-',
                        })
                        .then((response) => {
                            this.$toast.add({
                                severity: "success",
                                summary: "Success",
                                detail: Pesan.success,
                                life: 3000,
                            });
                            window.location.reload();
                        })
                        .catch((error) => {
                            this.$toast.add({
                                severity: "error",
                                summary: "Error",
                                detail: Pesan.error,
                                life: 3000,
                            });
                        });
                },
                reject: () => {
                    //
                },
            });

        },
        undang: function (event) {
            // console.log('asas');
            // tampilkan modal
            this.displayBasic = true;

        },
        lengkap: function (event, data) {
            this.$confirm.require({
                target: event.currentTarget,
                message:
                    "Apakah " + data + " Lengkap (" + this.dataPenyedia.nama_perusahaan +
                    ") ?",
                icon: "pi pi-info-circle",
                acceptClass: "p-button-info",
                accept: () => {

                    let penyedia = this.dataPenyedia;
                    axios
                        .post(route("penyedia.lengkap"), {
                            id: penyedia.id,
                            data: data,
                        })
                        .then((response) => {
                            this.$toast.add({
                                severity: "success",
                                summary: "Success",
                                detail: Pesan.success,
                                life: 3000,
                            });
                            window.location.reload();
                        })
                        .catch((error) => {
                            this.$toast.add({
                                severity: "error",
                                summary: "Error",
                                detail: Pesan.error,
                                life: 3000,
                            });
                        });
                },
                reject: () => {
                    //
                },
            });

        },
        tidaklengkap: function (event, data) {
            this.$confirm.require({
                target: event.currentTarget,
                message:
                    "Apakah " + data + " Belum Di Verifikasi (" + this.dataPenyedia.nama_perusahaan +
                    ") ?",
                icon: "pi pi-info-circle",
                acceptClass: "p-button-info",
                accept: () => {

                    let penyedia = this.dataPenyedia;
                    axios
                        .post(route("penyedia.tidaklengkap"), {
                            id: penyedia.id,
                            data: data,
                        })
                        .then((response) => {
                            this.$toast.add({
                                severity: "success",
                                summary: "Success",
                                detail: Pesan.success,
                                life: 3000,
                            });
                            window.location.reload();
                        })
                        .catch((error) => {
                            this.$toast.add({
                                severity: "error",
                                summary: "Error",
                                detail: Pesan.error,
                                life: 3000,
                            });
                        });
                },
                reject: () => {
                    //
                },
            });

        },
        undangKlarifikasi: function (event) {
            let penyedia = this.dataPenyedia;
            // update data
            // console.log(this.tanggal);
            axios
                .post(route("penyedia.undangKlarifikasi"), {
                    ids: [penyedia.id],
                    tanggal: this.tanggal,
                    lokasi: this.lokasi,
                    keterangan: this.keterangan,
                    no_hp: this.no_hp,
                })
                .then((response) => {
                    console.log(response);
                    this.$toast.add({
                        severity: "success",
                        summary: "Success",
                        detail: Pesan.success,
                        life: 3000,
                    });
                    window.location.reload();
                    this.displayBasic = false;
                })
                .catch((error) => {
                    console.log(error);
                });

        },
        tolak: function (event) {
            this.$confirm.require({
                target: event.currentTarget,
                message:
                    "Apakah akan Menolak (" + this.dataPenyedia.nama_perusahaan +
                    ") ?",
                icon: "pi pi-info-circle",
                acceptClass: "p-button-info",
                accept: () => {

                    let cek = true;
                    let penyedia = this.dataPenyedia;
                    if (penyedia.status == '4') {
                        cek = false;
                    }

                    // update data
                    if (cek == false) {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: 'data sudah ditolak',
                            life: 3000,
                        });
                        return false;
                    }
                    axios
                        .post(route("penyedia.verifikasi"), {
                            ids: [penyedia.id],
                            status: '4',
                            keterangan: '-',
                        })
                        .then((response) => {
                            this.$toast.add({
                                severity: "success",
                                summary: "Success",
                                detail: Pesan.success,
                                life: 3000,
                            });
                            window.location.reload();
                        })
                        .catch((error) => {
                            this.$toast.add({
                                severity: "error",
                                summary: "Error",
                                detail: Pesan.error,
                                life: 3000,
                            });
                        });
                },
                reject: () => {
                    //
                },
            });

        },
    }
})
</script>
